// extracted by mini-css-extract-plugin
export default {"container":"Main_container__Twh+e","separator":"Main_separator__ixVfb","grid":"Main_grid__GkJph","card":"Main_card__C3nM1","tags":"Main_tags__-yN0-"};